<script lang="ts">
    import ProgressClock from './ProgressClock.svg';
    import { afterUpdate } from 'svelte';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';

    // https://blog.logrocket.com/build-svg-circular-progress-component-react-hooks/
    export let progress: number;

    let size = 100;
    let strokeWidth = 14;
    let center = size / 2;
    let radius = center - strokeWidth;
    let arcLength = 2 * 3.1415 * radius;
    let arcOffset = arcLength;

    function calculateOffset(progress: number) {
        arcOffset = arcLength * ((100 - progress) / 100);
        arcOffset = Math.max(0, Math.min(arcLength, arcOffset));
        currentTweened.set(arcOffset);
    }

    const currentTweened = tweened(arcLength, {
        duration: 500,
        easing: cubicOut,
    });

    $: calculateOffset(progress);
</script>

<div style="width: 100px; height: 100px; transform: scale(0.25); margin: -75% -75%;">
    <svg class="svg-indicator" viewBox="0 0  100 100">
        <circle class="svg-indicator-track" />
        <circle
            class="svg-indicator-indication"
            stroke-dasharray={arcLength}
            stroke-dashoffset={$currentTweened}
        />
    </svg>
</div>

<style>
    .svg-indicator {
        width: 100px;
        height: 100px;
        transform: rotate(-90deg);
    }
    .svg-indicator-track,
    .svg-indicator-indication {
        cx: 50px;
        cy: 50px;
        r: 35px;
        fill: transparent;
        stroke-width: 18px;
    }

    /* Some color to highlight the rings */
    .svg-indicator-track {
        stroke: var(--automapa-grey-light);
    }

    .svg-indicator-indication {
        stroke: var(--planning-page-accent-color);
    }
</style>
